// ECRIT A LA MAIN (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Une fleche en equerre qui revient vers la gauche : REPONDRE DANS LE FIL,
 * derniere action de la barre d'actions d'un message (`BarreDActionsDuMessage`).
 * Glyphe de TRAIT (cadre `0 0 20 20`, trait 1.6) dessine pendant les retouches
 * du 06/10/2026 : `fill="none"` sur le trace, l'encre passe par `stroke`.
 */
export const IconReplyThread = createCustomIcon(
  'IconReplyThread',
  '0 0 20 20',
  <path d="m8 4-5 5 5 5M3 9h8a6 6 0 0 1 6 6" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />,
);
